<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Bill No：{{ formData.shipmentPayStatementNo || 'New' }}
        </span>
        <el-divider
          direction="vertical"
          v-if="formData.shipmentPayStatementStatus"
        ></el-divider>
        <b-badge
          v-if="formData.shipmentPayStatementStatus"
          style="font-size: 12px"
          :variant="
            formData.shipmentPayStatementStatus === 'W'
              ? 'primary'
              : formData.shipmentPayStatementStatus === 'S'
              ? 'warning'
              : formData.shipmentPayStatementStatus === 'D' ||
                formData.shipmentPayStatementStatus === 'R'
              ? 'danger'
              : formData.shipmentPayStatementStatus === 'Y'
              ? 'success'
              : ''
          "
        >
          {{ formData.v_shipmentPayStatementStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_customer') || '客户'"
            prop="custCode"
          >
            <dict-select
              size="mini"
              clearable
              v-model="formData.custCode"
              filterable
              url="/master/common/dict/customerSelect"
              @change="clearShare"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_expenseCust') || '费用客户'"
            prop="expenseCustCode"
          >
            <dict-select
              size="mini"
              clearable
              v-model="formData.expenseCustCode"
              filterable
              url="/master/common/dict/customerSelect"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_brand') || '品牌'">
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('form_label_please_select_brand') || '请选择品牌'
              "
              style="width: 100%"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_partyType') || '结算方类型'"
            prop="payTo"
          >
            <el-select
              v-model="formData.payTo"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              style="width:100%"
            >
              <el-option
                value="F"
                :label="$l('form_label_partyType_freightForwarder') || '货代'"
              ></el-option>
              <el-option
                value="T"
                :label="
                  $l('form_label_partyType_transportationCompany') || '运输公司'
                "
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_party') || '结算方'"
            prop="payScmCode"
          >
            <dict-select
              v-model="formData.payScmCode"
              url="/master/common/dict/allScmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              style="width:100%"
              @change="payScmChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_payScmBankName') || '开户银行'"
            prop="bankName"
          >
            <el-input v-model="formData.bankName" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePayScmBank"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payScmBankAccountName') || '账户名称'"
          >
            <el-input v-model="formData.bankAccountName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payScmBankAccountNo') || '银行账号'"
          >
            <el-input v-model="formData.bankAccountNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_payScmBankAccountType') || '账户性质'"
          >
            <el-input v-model="formData.v_bankAccountType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_payScmBankAccountKind') || '账号类别'"
          >
            <el-input v-model="formData.v_bankAccountKind" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_payer') || '付款方'"
            prop="payerCode"
          >
            <dict-select
              v-model="formData.payerCode"
              :selectedLabel.sync="formData.payerName"
              url="/master/common/dict/biz"
              :body="expensePayerParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="formData.payTo === 'F'">
          <el-form-item
            :label="$l('form_label_paymentMethod') || '付款方式'"
            prop="paymentMethod"
          >
            <dict-select
              v-model="formData.paymentMethod"
              url="/master/common/dict/biz"
              :body="paymentMethodParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_currencyTotalAmount') || '费用合计'"
          >
            <el-input v-model="v_currencyTotalAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_remark') || '付款用途'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="200"
              show-word-limit
              type="textarea"
              :rows="2"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_description') || '说明（不参与打印）'"
            prop="description"
          >
            <el-input
              v-model="formData.description"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="2"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ShareTable
          ref="shareTable"
          :disabled="disabled"
          :title="
            $l('form_label_shipment_pay_statement_share') || '外运单分摊明细'
          "
          :tableData="formData.listShare"
          :custCode="formData.custCode"
          :currencyTotalAmount="formData.currencyTotalAmount"
        />
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :tableData="formData.listItem"
          @updateTotAmount="(e) => (formData.currencyTotalAmount = e)"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :tableData="formData.listDoc"
        />
      </el-row>
    </el-form>

    <ChooseScmBank
      :visible.sync="chooseScmBankVisible"
      :title="$l('dialog_title_choose_payScmBank') || '选择结算方银行信息'"
      @confirm="updateBanInfo"
      :scmCode="formData.payScmCode"
    />
    <RepeatShare
      :visible.sync="repeatShareOptions.visible"
      :data="repeatShareOptions.data"
      @confirm="save({ shareRepeat: 'Y' })"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import ShareTable from '../share-table'
import DocTable from '../doc-table'
import ChooseScmBank from '../choose-scm-bank'
import RepeatShare from '../repeat-share/dialog.vue'
import { add } from '@/libs/util.number.js'
export default {
  components: {
    ItemTable,
    DocTable,
    ChooseScmBank,
    ShareTable,
    RepeatShare,
  },
  mixins: [EditLoading],
  props: {
    shipmentPayStatementCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isAppend: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        currencyTotalAmount: 0,
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        v_bankAccountType: '',
        bankAccountKind: '',
        v_bankAccountKind: '',
        paymentMethod: '5', // 5-网银
      },
      chooseScmBankVisible: false,
      repeatShareOptions: { visible: false, data: [] },
      expensePayerParams: { dictType: 'expensePayer' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
    }
  },
  computed: {
    v_currencyTotalAmount() {
      const { currencyTotalAmount } = this.formData
      return !currencyTotalAmount ? '' : currencyTotalAmount.toLocaleString()
    },
    rules() {
      return {
        shipmentContractNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payTo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        paymentMethod: [
          {
            required: this.formData.payTo === 'F',
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        bankName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expenseCustCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        description: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.shipmentPayStatementCode) return
      this.$api
        .shipmentPayStatementDetailApi({
          shipmentPayStatementCode: this.shipmentPayStatementCode,
        })
        .then((res) => {
          const data = res.body
          if (this.isAppend) {
            data.shipmentPayStatementCode = ''
            data.shipmentPayStatementNo = ''
            data.currencyTotalAmount = 0
            data.shipmentPayStatementStatus = ''
            data.v_shipmentPayStatementStatus = ''
            data.createByName = ''
            data.createTime = ''
            data.modifyByName = ''
            data.modifyTime = ''
            data.listItem = []
            data.listShare = []
            data.listDoc = []
            data.isAppend = 'Y'
          }
          this.formData = data
        })
    },
    async save({ shareRepeat = 'N' } = {}) {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      const listDoc = this.$refs.docTable.getTableData()
      const listShare = this.$refs.shareTable.getTableData()

      //比较分摊明细金额与费用合计金额是否相等
      var allShareAmount = 0
      listShare.forEach(
        (i) => (allShareAmount = add(allShareAmount, i.shareAmount))
      )
      if (allShareAmount != this.formData.currencyTotalAmount) {
        this.$message.error(
          this.$l('form_label_atypism') || '分摊明细金额与费用合计金额不一致'
        )
        return
      }

      // 如果结算方类型是运输公司，清空‘付款方式’两个字段
      if ('T' === this.formData.payTo) {
        this.formData.paymentMethod = ''
      }

      this.loadingOpen()
      const params = {
        ...this.formData,
        listItem,
        listDoc,
        listShare,
        shareRepeat,
      }
      const res = await this.$api
        .shipmentPayStatementSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status == 203) {
        this.getShareData(params)
        return
      }
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.repeatShareOptions.data = []
      this.repeatShareOptions.visible = false
      if (!this.shipmentPayStatementCode || this.isAppend) {
        this.closeCurPage()
      } else {
        this.getData()
      }
    },

    getShareData(form) {
      this.loadingOpen()
      this.$api
        .shipmentPayStatementShareListApi({
          ...form,
        })
        .then((res) => {
          this.loadingClose()
          this.repeatShareOptions.data = res.body.data
          this.repeatShareOptions.visible = true
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      const listShareResult = await this.$refs.shareTable.validate()
      return formResult && itemTableResult && listShareResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    async payScmChange(scmCode) {
      const res = await this.$api
        .masterScmInfoBankListApi({ scmCode })
        .catch(() => null)
      if (!res) return
      const listBank = res.body.data
      const bankData = !listBank || listBank.length > 1 ? {} : listBank[0] || {}
      this.updateBanInfo(bankData)
    },
    openChoosePayScmBank() {
      const { payScmCode } = this.formData
      if (!payScmCode) {
        this.$message({
          message:
            this.$l('tips_please_select_the_settlement_party_first') ||
            '请先选择结算方',
          type: 'warning',
        })
        return
      }
      this.chooseScmBankVisible = true
    },
    clearShare() {
      this.formData.listShare = []
    },
    updateBanInfo(e) {
      const {
        bankName = '',
        bankAccountName = '',
        bankAccountNo = '',
        bankAccountType = '',
        v_bankAccountType = '',
        bankAccountKind = '',
        v_bankAccountKind = '',
      } = e || {}
      this.formData.bankName = bankName
      this.formData.bankAccountName = bankAccountName
      this.formData.bankAccountNo = bankAccountNo
      this.formData.bankAccountType = bankAccountType
      this.formData.v_bankAccountType = v_bankAccountType
      this.formData.bankAccountKind = bankAccountKind
      this.formData.v_bankAccountKind = v_bankAccountKind
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
